import { Button, ButtonProps, IconButton } from '@mui/material';
import React, { useState } from 'react'

/**
 * API実行中はボタンを非活性にする
 */
export interface SubmitButtonProps extends Omit<ButtonProps, 'disabled'> {
  disabled?: boolean;
  isIcon?: boolean;
  validate: () => Promise<boolean>;
  onSubmit: () => Promise<boolean>; // ボタンを非活性にする場合に true を返すこと
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ disabled, isIcon, validate, onSubmit, children, ...rest }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (disabled || isSubmitting) return

    setIsSubmitting(true);

    if(!await validate()){
      setIsSubmitting(false);
      return
    }

    try {
      if (!await onSubmit()) {
        setIsSubmitting(false);
      }
    } catch (error:any) {
      setIsSubmitting(false);
    }
  };

  const buttonProps: ButtonProps = {
    ...rest,
    disabled: disabled || isSubmitting,
    onClick: handleSubmit,
    children
  }

  return (
    <>
      { isIcon ? <IconButton {...buttonProps} /> : <Button {...buttonProps} />}
    </>
  )
}

export default SubmitButton
